// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
// var options {
//     root: document.querySelector('#scrollArea'),
//     rootMargin: '0px', // Margin around the root. Can have values similar to the CSS margin property, e.g. "10px 20px 30px 40px" (top, right, bottom, left). Defaults to all zeros.
//     threshold: 0, //  If you only want to detect when visibility passes the 50% mark, you can use a value of 0.5. If you want the callback to run every time visibility passes another 25%, you would specify the array [0, 0.25, 0.5, 0.75, 1]. The default is 0
// }


class Observer {
    
    constructor(node, onEnter, onLeave, options) {
        
        if ('IntersectionObserver' in window) { // https://caniuse.com/#search=intersectionobserver
            this.observer = new IntersectionObserver(entries => {
                const el = entries[0]
                if (el.isIntersecting) {
                    if (typeof onEnter === "function") {
                        onEnter()
                    }
                } else {
                    if (typeof onLeave === "function") {
                        onLeave()
                    }
                }
            }, options);
            
            this.observer.observe(node)
        }
        // Fallback for older browsers
        else {
            throw new Error('missing IntersectionObserver');
        }
    }
    
    destroy() {
        this.observer.disconnect()
        this.observer = null;
    }    
}

export default Observer


// Instead of Class ? 
// export default {
//     create() {
//     },
//     destroy() {
//     },
// }
